import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'
import { Button } from './ui/button'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  message?: string
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      // NO incluir detalles PHI. Solo nombre del error.
      message: error instanceof Error ? error.name : 'render_error',
    }
  }

  componentDidCatch(_error: unknown, _info: ErrorInfo): void {
    // NO loggear stack — props/state pueden contener PHI.
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-dvh flex-col items-center justify-center bg-zinc-950 text-zinc-100 px-6 text-center">
          <div className="max-w-md rounded-lg border border-zinc-800 bg-zinc-900 p-8 shadow-sm">
            <h1 className="text-xl font-semibold">Algo salió mal</h1>
            <p className="mt-2 text-sm text-zinc-400">
              Ocurrió un error inesperado al renderizar la pantalla. Puedes intentar recargar.
            </p>
            <p className="mt-3 font-mono text-xs text-zinc-500">
              Código: {this.state.message ?? 'unknown'}
            </p>
            <div className="mt-6 flex justify-center">
              <Button onClick={() => window.location.reload()}>Recargar</Button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
